const errorsHepler = (errors, langs) => {
  const objectLangs = {};
  Object.values(errors).forEach((items) =>
    Object.keys(items).forEach((item) =>
      langs.forEach((lang) =>
        item.toString() === lang ? (objectLangs[lang] = true) : null,
      ),
    ),
  );
  return objectLangs;
};

export default errorsHepler;
